<template>
	<AppLayout :title="trans('menu.events.certificates')">
		<Empty v-if="certifications.length === 0"/>
		<CardGrid v-else>
			<Card v-for="certification in certifications" :key="`certifications-${certification.id}`" :title="certification.certificate.certifiable.title" :subtitle="certification.certificate.title">
				<template #footer>
					<a :href="route('events.certificates.download', certification.id)" target="_blank">
						<SecondaryButton :color="Color.Green">
							<i class="fa-solid fa-download mr-2"/>
							{{ trans('general.download') }}
						</SecondaryButton>
					</a>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/Empty.vue'
import Card from '@/Components/Cards/Card.vue'
import {ref, type Ref, defineProps} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import CardGrid from '@/Components/Cards/CardGrid.vue'
import {type Certification} from '@/Types/Certificates/Certification'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'

const props = defineProps<{
	certifications:Array<Certification>,
}>()

const certifications:Ref<Array<Certification>> = ref(props.certifications)
</script>